module.exports = __webpack_public_path__ + "media/images/flags/16/Kyrgyzstan-9a3c321db7247dbde0c8306223a7e0c3.png";